import styled from "styled-components";

export const ModuleContainer = styled.div`
  margin-bottom: 20px;
  border-radius: 10px;
  padding: 40px;
  margin: 30px;
`;

export const ModuleTitle = styled.h2`
  color: white;
  margin-bottom: 10px;
  font-size: 2rem;
  padding-left: 20px;
`;

export const RowContainer = styled.div`
  padding: 30px 20px;
`;

export const CardContainer = styled.div`
  max-width: 350px;
  position: relative;
  border-radius: 10px;
  flex: 0 0 auto;
  scroll-snap-align: start;
  cursor: pointer;
  transition: transform 0.3s ease;
  box-shadow: #000000a1 0px 0px 10px;
  overflow: hidden;
  &:hover {
    transform: scale(1.05);
  }
`;

export const Thumb = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
`;

export const ContentOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
background-color: rgb(0 0 0 / 24%); /* Cor da película de "vidro" */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  text-align: center;
  border-radius: 10px;
`;

export const Title = styled.h3`
  margin: 0;
  color: white;
`;

export const Description = styled.p`
  color: white;
`;

export const Rating = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

export const Star = styled.span`
  color: gold;
  font-size: 1.5rem;
  margin-right: 3px;
`;

export const ModalContent = styled.div`
  position: relative;
  padding: 20px;
  background: #1A1D23;
  border-radius: 10px;
  width: 100%;
  height: 100%;
`;

export const ModalClose = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
`;

export const Thumbnail = styled.iframe`
  width: 100%;
  height: 90vh;
  border: none;
  border-radius: 10px;
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: #1A1D23;
  border-top: 1px solid #444;
`;

export const PlayButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
`;

export const Progress = styled.input`
  flex: 1;
  margin: 0 10px;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  background: #444;
  height: 5px;
  border-radius: 5px;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #2af497; /* Cor do controle do progresso */
  }
  &::-moz-range-thumb {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #2af497; /* Cor do controle do progresso */
  }
`;
export const CustomSwiperPagination = styled.div`
  .swiper-button-prev,
  .swiper-button-next {
    width: auto;
    height: auto;
    top: 50%;
    transform: translateY(-50%) !important;
    z-index: 10;
  }

  .swiper-button-prev {
    left: 10px !important; /* Ajuste conforme necessário */
  }

  .swiper-button-next {
    right: 10px; /* Ajuste conforme necessário */
  }

  .swiper-pagination-bullet {
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.primary};
  }

  .swiper-pagination-bullet-active {
    background-color: ${({ theme }) => theme.primary};
  }

  .swiper-button-next:after, .swiper-rtl .swiper-button-prev:after {
    content: 'next';
    transform: translateX(-100%);
}
`;

export const Video = styled.iframe`
  width: 100%;
 height: 100%;
  outline: none; /* Remover a borda padrão do vídeo quando está focado */
  border: none; /* Remover a borda do iframe */
`;
